import type { DragEvent } from "react"
import { MERGE_TAG_DRAG_TYPE } from "./constants"
import { applyMergeTagDragImage } from "./mergeTagDragImage"
import { setActiveMergeTagDrag, type MergeTagDragPayload } from "./mergeTagDragStore"

export const MERGE_TAG_INTERACTIVE_SELECTOR = "[data-merge-tag-interactive]"

export const isMergeTagInteractiveTarget = (target: EventTarget | null): boolean => (
  target instanceof Element && !!target.closest(MERGE_TAG_INTERACTIVE_SELECTOR)
)

export const handleMergeTagDragStart = (
  event: DragEvent<HTMLElement>,
  payload: MergeTagDragPayload,
): void => {
  if (isMergeTagInteractiveTarget(event.target)) {
    event.preventDefault()

    return
  }

  const { dataTransfer } = event
  if (!dataTransfer) return

  setActiveMergeTagDrag(payload)
  dataTransfer.setData(MERGE_TAG_DRAG_TYPE, JSON.stringify(payload))
  dataTransfer.effectAllowed = "move"
  applyMergeTagDragImage(event)
}
